import { h } from 'preact'

import InputGroup from '../../control-components/ui-components/InputGroup'
import ButtonControl from '../button-control'
interface Props {
  credentials: { id: string, secret: string }
  onClickCopy: (field: 'id' | 'secret') => void
}

const Credentials = ({ credentials, onClickCopy }: Props) => {
  return (
    <section>
      <InputGroup
        newStyle
        title='Client ID'
        customInput={
          <div class='cridential-row'>
            <input class='form-control' value={credentials.id} disabled />
            <ButtonControl newStyle size='medium' variant='brand' title='Copy' onClick={() => onClickCopy('id')} class='qa-copy' />
          </div>
        }
      />
      <InputGroup
        newStyle
        title='Client secret'
        formGroupClasses='last-group'
        customInput={
          <div class='cridential-row'>
            <input class='form-control' value={credentials.secret} disabled />
            <ButtonControl newStyle size='medium' variant='brand' title='Copy' onClick={() => onClickCopy('secret')} class='qa-copy' />
          </div>
        }
      />
    </section>
  )
}

export default Credentials
